import { pathValuesFromYearToYear, pathValuesWithYear } from '@predium/client-lookup';
import { getMainPathConfig } from './getMainPathConfig';
import { ActionPlanImpactTrendsChartCo2Emissions, LineChartSeriesType } from './types';

export const getStrandingYearsPaths = (
  co2Emissions: ActionPlanImpactTrendsChartCo2Emissions,
  color: string,
  trendStartYear: number,
  pathNames?: { afterActionsName: string; beforeActionsName: string },
): LineChartSeriesType[] => {
  const { stranding_ranges } = co2Emissions;

  if (!stranding_ranges) return [];

  const hasActions = co2Emissions.annotations.some((annotation) => annotation.annotation_type === 'ACTION');

  return stranding_ranges.map((range) => {
    if (hasActions) {
      return getMainPathConfig({
        name: pathNames?.afterActionsName ?? '',
        data: pathValuesWithYear(
          pathValuesFromYearToYear(co2Emissions.after_actions_path, range.start_year, range.end_year),
          trendStartYear,
        ),
        color,
        tooltipYearValue: range.start_year,
      });
    }

    return getMainPathConfig({
      name: pathNames?.beforeActionsName ?? '',
      data: pathValuesWithYear(
        pathValuesFromYearToYear(co2Emissions.before_actions_path, range.start_year, range.end_year),
        trendStartYear,
      ),
      color,
      tooltipYearValue: range.start_year,
    });
  });
};
